<template>
  <div class="container-fluid m-0 p-0" v-if="user">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div
              class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3"
            >
              <h6 class="text-white ps-3">Maior e menor cota</h6>
            </div>
          </div>

          <div class="card-body p-4">
            <v-container>
              <v-row>
                <v-col v-if="user.role === 'ADMIN'">
                  <label class="input-label w-100">
                    <span
                      class="text-xs text-uppercase text-body font-weight-bolder"
                    >
                      Selecione um usuário
                    </span>
                    <div class="d-flex align-items-center position-relative">
                      <AutoComplete
                        v-model="userSelected"
                        dropdown
                        optionLabel="full_name"
                        @complete="searchUsers"
                        @option-select="handleUser"
                        @clear="handleClear"
                        :suggestions="filteredUsers"
                        placeholder="Selecione..."
                        class="bordered-autocomplete"
                        emptySearchMessage="Nenhum usuário encontrado"
                      />
                    </div>
                  </label>

                  <DefaultSelect
                    v-if="userSelected"
                    label="Selecione uma campanha"
                    :options="raffles"
                    itemText="name"
                    itemValue="id"
                    @change="handleCampaign"
                    placeholder="Selecione..."
                  />
                </v-col>

                <div v-if="user.role === 'USER'" class="campaign-select">
                  <DefaultSelect
                    label="Selecione uma campanha"
                    :options="raffles"
                    itemText="name"
                    itemValue="id"
                    @change="handleCampaign"
                    placeholder="Selecione..."
                  />
                </div>
              </v-row>

              <v-row class="mt-4 w-100" v-if="campaignSelected" align="center">
                <v-col class="filters-field">
                  <div class="w-100">
                    <DefaultInput
                      type="datetime-local"
                      v-model="minMaxDates.initial"
                      class="mb-0"
                      style="min-width: 180px"
                      label="Data inicial"
                    />
                  </div>

                  <div class="w-100">
                    <DefaultInput
                      type="datetime-local"
                      v-model="minMaxDates.final"
                      class="mb-0"
                      style="min-width: 180px"
                      label="Data final"
                    />
                  </div>

                  <div class="d-flex align-items-end button">
                    <DefaultButton
                      label="Buscar"
                      :buttonColor="'#198754'"
                      :textColor="'#ffffff'"
                      @confirm="getMinMaxQuotas(campaignSelected)"
                      style="
                        padding: 4px 16px;
                        font-size: 0.9rem;
                        min-width: 90px;
                        margin-bottom: 0.5rem;
                      "
                    />
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="maxMinQuota">
                <v-col cols="12">
                  <div class="p-3 mt-2 bg-light border rounded">
                    <div class="quota-result-grid">
                      <div class="quota-card quota-min">
                        <div class="quota-card-title">
                          <h6 class="mb-0">Menor cota comprada</h6>
                          <a
                            v-if="maxMinQuota.min_participant?.phone"
                            :href="
                              getWhatsAppUrl(maxMinQuota.min_participant.phone)
                            "
                            target="_blank"
                            rel="noopener"
                            class="button-whatsapp"
                            title="Entrar em contato via WhatsApp"
                          >
                            Falar no WhatsApp
                          </a>
                        </div>
                        <p class="mb-1">
                          <strong>Cota:</strong>
                          {{ formatQuota(maxMinQuota.min_quota) }}
                        </p>
                        <p class="mb-1">
                          <strong>Nome:</strong>
                          {{ maxMinQuota.min_participant?.name }}
                        </p>
                        <p class="mb-1">
                          <strong>Telefone:</strong>
                          {{
                            formatTelephonePrivacy(
                              maxMinQuota.min_participant?.phone
                            )
                          }}
                        </p>
                        <p class="mb-1">
                          <strong>Total de cotas na compra:</strong>
                          {{ maxMinQuota.min_participant?.total_quotas }}
                        </p>
                        <p class="mb-1">
                          <strong>Valor total:</strong>
                          {{
                            addMoneyMask(
                              maxMinQuota.min_participant?.total_value
                            )
                          }}
                        </p>
                        <p class="mb-1">
                          <strong>Data:</strong>
                          {{
                            formatDate(maxMinQuota.min_participant?.created_at)
                          }}
                        </p>
                      </div>
                      <div class="quota-card quota-max">
                        <div class="quota-card-title">
                          <h6 class="mb-0">Maior cota comprada</h6>
                          <a
                            v-if="maxMinQuota.max_participant?.phone"
                            :href="
                              getWhatsAppUrl(maxMinQuota.max_participant.phone)
                            "
                            target="_blank"
                            rel="noopener"
                            class="button-whatsapp"
                          >
                            Falar no WhatsApp
                          </a>
                        </div>
                        <p class="mb-1">
                          <strong>Cota:</strong>
                          {{ formatQuota(maxMinQuota.max_quota) }}
                        </p>
                        <p class="mb-1">
                          <strong>Nome:</strong>
                          {{ maxMinQuota.max_participant?.name }}
                        </p>
                        <p class="mb-1">
                          <strong>Telefone:</strong>
                          {{
                            formatTelephonePrivacy(
                              maxMinQuota.max_participant?.phone
                            )
                          }}
                        </p>
                        <p class="mb-1">
                          <strong>Total de cotas na compra:</strong>
                          {{ maxMinQuota.max_participant?.total_quotas }}
                        </p>
                        <p class="mb-1">
                          <strong>Valor total:</strong>
                          {{
                            addMoneyMask(
                              maxMinQuota.max_participant?.total_value
                            )
                          }}
                        </p>
                        <p class="mb-1">
                          <strong>Data:</strong>
                          {{
                            formatDate(maxMinQuota.max_participant?.created_at)
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading" />
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import DefaultSelect from "@/components/DefaultSelect.vue";
import DefaultInput from "@/components/DefaultInput.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import AutoComplete from "primevue/autocomplete";
import { addMoneyMask } from "@/helpers/moneyMask.js";
import { formatQuota } from "@/helpers/formatQuota.js";

import UsersHttp from "@/http/UsersHttp.js";
import RafflesHttp from "@/http/RafflesHttp.js";
import ParticipantsHttp from "@/http/ParticipantsHttp.js";

export default {
  name: "LowestAndHighestQuotas",
  components: {
    Loading,
    DefaultSelect,
    DefaultInput,
    DefaultButton,
    AutoComplete,
  },
  data() {
    return {
      user: null,
      userSelected: null,
      campaignSelected: "",
      campaignSelectedDetails: null,
      raffles: [],
      filteredUsers: [],
      maxMinQuota: null,
      loading: false,
      users: [],
      minMaxDates: {
        initial: "",
        final: "",
      },
    };
  },
  async mounted() {
    this.user = this.$store.getters.user;
    if (this.user.role === "ADMIN") await this.getUsers();
    if (this.user.role === "USER") await this.getRaffles();
    const now = new Date();
    const year = now.getFullYear();
    this.minMaxDates.initial = `${year}-01-01T00:00`;
    this.minMaxDates.final = `${year}-12-31T23:59`;
  },
  methods: {
    async getUsers() {
      try {
        const res = await UsersHttp.getUsersMinimum();
        this.users = res.data;
      } catch (err) {
        console.error(err);
      }
    },
    async getRaffles() {
      try {
        const res = await RafflesHttp.getRafflesMinimum();
        this.raffles = res.data;
      } catch (err) {
        console.error(err);
      }
    },
    async handleUser(e) {
      const id = e.value.id;
      this.userSelected = e.value;
      this.campaignSelected = "";
      try {
        const res = await RafflesHttp.getRafflesByUser(id);
        this.raffles = res.data;
      } catch (err) {
        console.error(err);
      }
    },
    async handleClear() {
      this.userSelected = null;
      this.campaignSelected = "";
      this.raffles = [];
      this.maxMinQuota = null;
      this.filteredUsers = [];
    },
    searchUsers(e) {
      const query = e.query.toLowerCase();
      this.filteredUsers = this.users.filter((u) =>
        u.full_name.toLowerCase().startsWith(query)
      );
    },
    async handleCampaign(e) {
      let campaignId = null;
      if (e && e.target && e.target.value) {
        campaignId = e.target.value;
      } else if (typeof e === "string" || typeof e === "number") {
        campaignId = e;
      } else if (e && e.value) {
        campaignId = e.value;
      }
      this.campaignSelected = campaignId;
      this.campaignSelectedDetails = this.raffles.find(
        (r) => r.id === campaignId
      );
      this.maxMinQuota = null;
    },
    async getMinMaxQuotas(campaignIdParam) {
      let campaignId = campaignIdParam;
      if (!campaignId) campaignId = this.campaignSelected;
      if (!campaignId) return;

      if (!this.minMaxDates.initial || !this.minMaxDates.final) {
        this.$toast?.add?.({
          severity: "warn",
          summary: "Atenção",
          detail: "Preencha as datas inicial e final.",
          life: 3000,
        });
        return;
      }

      try {
        this.loading = true;
        const response = await ParticipantsHttp.getMinMaxQuotas(campaignId, {
          initial: this.minMaxDates.initial.replace("T", " ") + ":00",
          final: this.minMaxDates.final.replace("T", " ") + ":00",
        });
        this.maxMinQuota = response.data;
      } catch (error) {
        this.$toast?.add?.({
          severity: "warn",
          summary: "Atenção",
          detail: "Houve um erro ao buscar as cotas.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    },
    getWhatsAppUrl(telefone) {
      const baseURL = "https://wa.me/";
      return `${baseURL}${telefone}`;
    },
    formatTelephonePrivacy(phone) {
      const digits = String(phone || "").replace(/\D/g, "");
      if (!digits) return "Telefone indisponível";

      const last4 = digits.slice(-4);
      if (digits.length >= 11) {
        const ddd = digits.slice(0, 2);
        const ninth = digits.slice(2, 3);
        return `(${ddd}) ${ninth} ****-${last4}`;
      }
      if (digits.length >= 10) {
        const ddd = digits.slice(0, 2);
        return `(${ddd}) ****-${last4}`;
      }
      return `****-${last4}`;
    },
  },
  computed: {
    addMoneyMask() {
      return (value) => (value ? addMoneyMask(value) : "Valor indisponível");
    },
    formatQuota() {
      return (quota) =>
        quota !== null || quota !== undefined
          ? formatQuota(quota)
          : "Cota indisponível";
    },
  },
};
</script>

<style scoped lang="scss">
.form-control {
  width: 100%;
  padding: 8px;
  font-size: 0.9rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.quota-result-grid {
  display: flex;
  flex-direction: row;
  gap: 32px;
}

.quota-card {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e3e3e3;
  box-shadow: 0 2px 8px #0001;
  padding: 18px 22px;
  width: 100%;
}

.quota-card-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.quota-min {
  border-left: 6px solid #661bb0;

  h6 {
    color: #661bb0;
  }
}

.quota-max {
  border-left: 6px solid #eb0e7e;

  h6 {
    color: #eb0e7e;
  }
}

.filters-field {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.button-whatsapp {
  background-color: #198754;
  color: white;
  font-size: 14px;
  border: none;
  padding: 0;
  cursor: pointer;
  font-weight: 500;
  padding: 0px 10px;
  border-radius: 8px;
}

@media (max-width: 900px) {
  .quota-card-title {
    flex-direction: column;
    align-items: flex-start;
  }

  .button-whatsapp {
    height: 30px;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
  }

  .quota-result-grid {
    flex-direction: column;
    gap: 18px;
  }

  .filters-field {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0px;

    .button {
      width: 100%;
      margin-top: 12px;
    }
  }
}
</style>
